import type { CampusEvent } from "@/app/types/events";

type SportsSourceLink = {
  href: string;
  label: "View details" | "Official schedule";
};

export function sportsSourceLink(
  event: Pick<CampusEvent, "source" | "host" | "source_url">,
): SportsSourceLink | null {
  try {
    const url = new URL(event.source_url);
    if (url.protocol === "https:" || url.protocol === "http:") {
      return { href: event.source_url, label: "View details" };
    }
  } catch {
    // A malformed or app-only source cannot serve a browser details action.
  }

  if (event.source !== "athletics") return null;

  return {
    href: event.host === "Rutgers Volleyball"
      ? "https://scarletknights.com/sports/womens-volleyball/schedule/text"
      : "https://scarletknights.com/calendar",
    label: "Official schedule",
  };
}
